import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    GET_ACCESS_LEVELS: createActionType(FULL_NAMESPACE, "GET_ACCESS_LEVELS"),
    GET_ACCESS_LEVELS_COMPLETED: createActionType(FULL_NAMESPACE, "GET_ACCESS_LEVELS_COMPLETED"),
    SET_IS_OPEN: createActionType(FULL_NAMESPACE, "SET_IS_OPEN")
};
